import config from '../../config/config';

export const SELF_LOAD = 'SELF/SELF_LOAD';
export const SELF_SUCCESS = 'SELF/SELF_SUCCESS';
export const SELF_FAILURE = 'SELF/SELF_FAILURE';

export function getSelfSuccessActionCreator(self) {
    return {
        self,
        type: SELF_SUCCESS
    };
}

export function getSelfFailureActionCreator(error) {
    return {
        error,
        type: SELF_FAILURE
    };
}

export function getSelf() {
    return {
        failureActionTypeOrCreator: getSelfFailureActionCreator,
        fetchParams: {
            url: `${config.userManagementApiUrl}/account/whoAmI`
        },
        loadActionTypeOrCreator: SELF_LOAD,
        successActionTypeOrCreator: getSelfSuccessActionCreator
    };
}
